import React from "react";
import Header from "./Header";
import MobileHeader from "./MobileHeader";
import HeroBackground from "./HeroBackground";

const Layout = ({ children }) => {
  return (
    <div className="max-w-[100vw] w-[100vw] relative h-[100vh] layout-bg">
      <div className="h-full overflow-y-scroll overflow-x-hidden no-scrollbar">
        <HeroBackground />
        <div className="relative z-10">
          <Header />
          <div className="flex justify-center items-start min-h-[calc(100vh-72px)] py-10 px-2 sm:px-4 pb-24 md:pb-10">
            {children}
          </div>
        </div>
      </div>
      <MobileHeader />
    </div>
  );
};

export default Layout;
